<template>
  <div class="global-container">
    <div class="card login-form">
      <div class="card-body">
        <div id="logo_home" style="text-align: center; margin-right: 0px">
          <h1>
            <img src="../../../public/img/logo-pardis.png" width="85%" alt="City tours" data-retina="true"
              @click.prevent="gotoHome" style="cursor: pointer" />
          </h1>
        </div>
        <div class="row">
          <h3 style="
              margin: 30px 20px !important;
              color: #635d5d;
              font-weight: 500;
            ">
            فعال سازی حساب کاربری
          </h3>
        </div>

        <div class="sign-in-wrapper">
          <!-- <div class="float-right" style="margin-bottom: 20px">
            <router-link to="/login"> بازگشت به صفحه ورود کاربر </router-link>
          </div> -->
          <div class="text-center">
            <button v-if="!isLoading" type="submit" @click.prevent="confirmEmail" class="btn_login">
              فعال سازی
            </button>

            <!-- <button v-if="isLoading" type="submit" class="btn_login">
              فعال سازی
              <loadingBar type="ring" class="loading-btn"></loadingBar>
            </button> -->
          </div>
        </div>
      </div>
    </div>
  </div>
</template>


<script>
import store from "../../store/index";
import loadingBar from "@/components/loading/pdkLoadingBar";

export default {
  name: "PdkLogin",
  store,
  components: {
    loadingBar,
  },

  data() {
    return { isLoading: false };
  },
  created() {
    this.confirmEmail();
  },
  methods: {
    async confirmEmail() {
      this.isLoading = true;

      const params = this.$route.query;

      const data = {
        email: params.email,
        code: params.code,
      };
      const res = await this.$store.dispatch("confirmEmail", data);

      //اپدیت پروفایل  به وضعیت در حال بررسی بعد از فعال سازی ایمیل

      if (res.status === 200) {
        const profileStatus = {
          profileId: params.userId,
          status: 3,
        };
        const updateProfile = await this.$store.dispatch(
          "updateProfileStatus",
          profileStatus
        );
        if (updateProfile.status == 200) {
          // alert("فعال سازی با موفقیت انجام پذیرفت");
          this.$toast.success("فعال سازی با موفقیت انجام پذیرفت", {
            position: "top-center",
            timeout: 4500,
            closeOnClick: true,
            pauseOnFocusLoss: true,
            pauseOnHover: true,
            draggable: true,
            draggablePercent: 1.59,
            showCloseButtonOnHover: false,
            hideProgressBar: false,
            icon: true,
            rtl: true,
          });
          this.$router.push("/login");
        } else {
          // alert("خطا در فعال سازی");
          this.$toast.error("خطا در فعال سازی", {
            position: "top-center",
            timeout: 4500,
            closeOnClick: true,
            pauseOnFocusLoss: true,
            pauseOnHover: true,
            draggable: true,
            draggablePercent: 1.59,
            showCloseButtonOnHover: false,
            hideProgressBar: false,
            icon: true,
            rtl: true,
          });
        }
        this.$router.push("/login");
      }
    },
    gotoHome() {
      if (this.$route.name != "main home") this.$router.push("/");
    },
  },
};
</script>
<style scoped>
.invalid {
  border: 1px solid red !important;
  box-shadow: 0 0 5px red !important;
}

.loading-btn {
  padding-right: 50px !important;
}

.small-dialog-header {
  font-size: 18px;
  width: calc(100%);
  right: 0px;
  top: 0;
  -webkit-border-radius: 4px 4px 0 0;
  -moz-border-radius: 4px 4px 0 0;
  border-radius: 4px 4px 0 0;
  display: inline-block;
  background-color: #fff;
  padding: 15px 20px;
  margin-bottom: 30px;
}

#logo_home h1 a,
header#colored #logo_home h1 a,
header#plain #logo_home h1 a,
header.sticky #logo_home h1 a {
  width: 160px;
  height: 34px;
  display: block;
  background-image: url(../../../public/img/pdk_logo.png);
  background-repeat: no-repeat;
  background-position: left top;
  background-size: 160px 34px;
  text-indent: -9999px;
  text-align: center;
  margin: 20px;
}
</style>

<style scoped>
html,
body {
  height: 100%;
  background-color: #f5f7f9;
}

.global-container {
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: #f5f7f9;
  padding-top: 10%;
}

.form-control {
  font-size: 13px;
  color: #333;
  height: 40px;
  border-radius: 3px;
  padding-right: 40px;
}

.card-title {
  font-weight: 300;
}

.btn {
  font-size: 14px;
  margin-top: 20px;
}

.login-form {
  width: 500px;
  margin: 20px;
}

.card-body {
  padding: 30px 15px 30px 15px;
  line-height: 1.6 !important;
  border-top: 0px solid;
}

.inputContainer i {
  position: absolute;
  margin: -34px 10px;
  text-align: left !important;
  float: left;
  font-size: 20px;
  color: #ccc;
}

.inputContainer {
  width: 100%;
  margin-bottom: 10px;
}
</style>